// @flow
import * as React from 'react';
import Box from 'sail/Box';
import {UnstyledLink} from 'sail/UnstyledLink';
import {useAccount} from 'docs/data';
import {normalizeHostname} from 'docs/util';
import {Heading, Body, Text} from 'sail/Text';

import LyftIcon from 'docs/images/company-icons/lyft.svg';
import ShopifyIcon from 'docs/images/company-icons/shopify.svg';
import {Badge} from '../../core/Badge/Badge';

type UseCaseGuideCardProps = {|
  children: React.Node,
  title: string,
  href: string,
  companyIcon: string,
  exampleText?: string,
  showPill?: Boolean,
  pillText?: string,
|};

const CompanyIcon = ({company}) => {
  let src = LyftIcon;
  switch (company) {
    case 'lyft':
      src = LyftIcon;
      break;
    case 'shopify':
      src = ShopifyIcon;
      break;
  }

  return (
    <Box margin={{right: 8}} flex={{alignItems: 'center'}}>
      <img width={24} height={24} src={src} alt="" />
    </Box>
  );
};

export const UseCaseGuideCard = ({
  children,
  title,
  href,
  companyIcon,
  exampleText,
  showPill,
  pillText,
}: UseCaseGuideCardProps) => {
  const {account} = useAccount();
  const pill =
    pillText && showPill ? <Badge label={pillText} color="gray" /> : null;
  const companyExample = companyIcon ? (
    <Box
      flex={{alignItems: 'center'}}
      padding={{top: 12}}
      style={{marginTop: 'auto'}}
    >
      <CompanyIcon company={companyIcon} />
      <Text style={{fontStyle: 'italic'}}>{exampleText}</Text>
    </Box>
  ) : null;
  return (
    <UnstyledLink
      className="Card Card--bordered"
      href={normalizeHostname(href, account.hosts)}
    >
      <Box flex={{direction: 'column'}} style={{height: '100%'}}>
        <Box
          flex={{
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          }}
        >
          <Heading
            color="blue"
            weight={500}
            size={16}
            className="GuideCard-title"
          >
            {title}
          </Heading>
          {pill}
        </Box>
        <Body className="GuideCard-description">{children}</Body>
        {companyExample}
      </Box>
    </UnstyledLink>
  );
};
